/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Fade from '@mui/material/Fade';

// Soft UI Dashboard PRO React base styles
import colors from '../colors';
import typography from '../typography';
import borders from '../borders';

// Soft UI Dashboard PRO React helper functions
import pxToRem from '../../functions/pxToRem';

const { black, light } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

export default {
    defaultProps: {
        arrow: true,
        TransitionComponent: Fade,
    },

    styleOverrides: {
        tooltip: {
            maxWidth: pxToRem(300),
            backgroundColor: black.main,
            color: light.main,
            fontSize: size.xs,
            fontWeight: fontWeightRegular,
            lineHeight: pxToRem(16),
            textAlign: 'center',
            borderRadius: borderRadius.md,
            opacity: 0.7,
            padding: `${pxToRem(5)} ${pxToRem(8)} ${pxToRem(4)}`,

            '.MuiTooltip-popper[data-popper-placement*="top"]  &.MuiTooltip-tooltipPlacementTop':
                {
                    marginBottom: pxToRem(10),
                },
        },

        arrow: {
            color: black.main,
        },
    },
};
